import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  aspect-ratio: 84/72;
  height: 100%;
  width: auto;
`;

const Path = styled.path(({ $active }: { $active: boolean }) => `
  stroke-dasharray: 232;
  stroke-dashoffset: ${$active ? "0" : "232"};

  transition: 0.5s stroke-dashoffset, 0.25s stroke;
`);

const HandwriteCircle = ({ color = "black", active = true }: {
  color?: string,
  active?: boolean
}) => (
  <Wrapper
    width={84} height={72}
    viewBox="0 0 84 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M2.17578 27.3705C10.9883 12.5397 23.2393 2.61901 41.1319 2.38664C50.9338 2.25934 60.1244 4.21225 67.9787 10.4041C77.4714 
          17.8876 83.8356 28.2152 80.7534 40.5443C78.374 50.0616 71.0122 58.5034 62.922 63.7317C55.8632 68.2936 45.0302 71.8267 
          36.8737 68.1563C28.6621 64.4611 24.2768 56.398 22.0697 48.0628C20.6274 42.616 19.716 36.8075 19.9073 31.1629C20.1323 
          24.5256 22.3139 18.7862 23.733 12.4001"
      stroke={color}
      strokeWidth={3}
      strokeLinecap="round"

      $active={active}
    />
  </Wrapper>
);

export default HandwriteCircle;